import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyCHlR2id4_5AAS8g0CpIeTB1onDa3WP2bY",
    authDomain: "inventario-provell.firebaseapp.com",
    projectId: "inventario-provell",
    storageBucket: "inventario-provell.appspot.com",
    messagingSenderId: "897309869889",
    appId: "1:897309869889:web:81cecec027d06155cd83c0"
});

export const auth = firebaseApp.auth();
export const firestore = firebaseApp.firestore();
export default firebaseApp;